import { createFileRoute } from '@tanstack/react-router';
import { KbCollectionView } from '@/features/kb/KbCollectionView';

function CollectionRoute() {
  const { slug } = Route.useParams();
  return <KbCollectionView slug={slug} />;
}

export const Route = createFileRoute('/kb/c/$slug')({ component: CollectionRoute });
